import { createKeys, featureKeys } from "Utilities/ReactQuery/fnKeys";

const SAVE_EXTENDED_FIELD = "saveExtendedField";

const extendedFieldKeys = createKeys(featureKeys.EXTENDED_FIELDS, {
  saveFields: () => [SAVE_EXTENDED_FIELD],
});

export default extendedFieldKeys;
